import { Component } from "react";
import styles from "./time-slot-item.module.less";
import { isArray, DateHelper } from "@parksandresorts/core";
import PropTypes from "prop-types";
import SiteConfigurationStore from "components/stores/site-configuration-store";

export default class TimeSlotItem extends Component {
  constructor(props) {
    super(props);

    this.timeslotDate = DateHelper.toStringTimeHHMM(this.props.timeSlotDate);
    this.leftLabel = SiteConfigurationStore.getLabel("REMAINING", "kvar");
  }

  render() {
    return (
      <button
        disabled={this.props.disabled}
        onClick={this.props.onClick}
        className={`${styles.timeslot} ${this.props.outOfStock ? styles.outOfStock : ""} ${
          this.props.selected ? styles.selected : ""
        }`}
      >
        {this.props.otherBookedAttractionName ? (
          <div className={styles.otherBookedAttractionName}>{this.props.otherBookedAttractionName}</div>
        ) : (
          <div>{this.timeslotDate}</div>
        )}
        {this.props.showQuantity && !this.props.otherBookedAttractionName ? (
          <p className={[styles.passesRemaining, "p_tiny"].join(" ")}>
            ({this.props.quantity} {this.leftLabel})
          </p>
        ) : null}
        {isArray(this.props.otherGuestBookings) && (
          <div className={styles.otherGuestColorDotWrapper}>
            {this.props.otherGuestBookings.map((booking, index) => (
              <div
                key={index}
                style={{ zIndex: index + 1, background: booking.color }}
                className={styles.otherGuestDot}
              />
            ))}
          </div>
        )}
      </button>
    );
  }
}

TimeSlotItem.propTypes = {
  disabled: PropTypes.bool,
  outOfStock: PropTypes.bool,
  otherGuestBookings: PropTypes.array,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};
